import BaseApi from '@/Services/Api/Company/V1/BaseApi'

export default {
  store(payload) {
    return BaseApi.post(`/v1/addresses`, payload)
  },
  update(uuid, payload) {
    return BaseApi.patch(`/v1/addresses/${uuid}`, payload)
  },
  show(uuid) {
    return BaseApi.get(`/v1/addresses/${uuid}`)
  },
}
